// extracted by mini-css-extract-plugin
module.exports = {"footer-row":"core_footer-row__2McC5","copyright":"core_copyright__1l3Qc","footer":"core_footer__3z63m"};